/**
 * Environment configuration.
 */
export const {
  PUBLIC_URL = '',
  REACT_APP_ACCESS_TOKEN_NAME = '',
  REACT_APP_ACCESS_TOKEN_NAME_MP = '',
  REACT_APP_API_BASE_URL = '',
  REACT_APP_API_PRINCIPAL_URL = '',
  REACT_APP_BASE_URL = '',
  REACT_APP_CAPACITACION_BASE_URL = '',
  REACT_APP_CENTROAYUDA_BASE_URL = '',
  REACT_APP_CHILECOMPRA_BASE_URL = '',
  REACT_APP_ENVIRONMENT = '',
  REACT_APP_GOOGLE_ANALYTICS_KEY = '',
  REACT_APP_GOOGLE_TASK_MANAGER_ID = '',
  REACT_APP_HOTJAR_ID = '',
  REACT_APP_HOTJAR_SNIPPET_VERSION = '',
  REACT_APP_MERCADO_PUBLICO_BASE_URL = ''
} = process.env

export const isDevEnv = REACT_APP_ENVIRONMENT !== 'prod'
export const isLocalEnv = REACT_APP_ENVIRONMENT === 'local'
export const isProdEnv = REACT_APP_ENVIRONMENT === 'prod'
